import React from 'react'
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import AuditTrailViewer from '../AuditTrail';
import useStyles from './style';


const ActionBarViewer = (props) => {
   const { isButtonEnable, isExport, isAuditTrail, handleAuditTrailDrawerToggle, auditTrailDrawerOpen, auditTrail, chartUniqueId, label, value, exportLabel, auditTrailLabel, blockState, handleExport, isUpdated, currentDocumentId } = props
   const classes = useStyles();
    return (
        <div className={classes.container}>
            <div className={classes.leftContainer}>
                <div className={classes.innerContainer}>
                    <div className={classes.blueBar}>

                    </div>
                    <Typography className={classes.labelText}>{`${label} :`}</Typography>
                    <Typography className={classes.valueText}>{blockState?.[value]}</Typography>
                </div>
            </div>
            {
                isButtonEnable && isUpdated && (
                    <div className={classes.buttonContainer}>
                        {
                            isExport && <Button
                                className={classes.exportButton}
                                onClick={() => { handleExport(blockState?._id || blockState?.id || currentDocumentId, blockState) }}
                            >
                                {exportLabel}
                            </Button>
                        }
                        {
                            isAuditTrail && <Button
                                className={classes.auditTrailButton}
                                onClick={handleAuditTrailDrawerToggle}

                            >
                                {auditTrailLabel}
                            </Button>
                        }
                    </div>
                )
            }

            {
                isButtonEnable && isAuditTrail && (
                    <Drawer
                        anchor="right"
                        open={auditTrailDrawerOpen}
                        onClose={handleAuditTrailDrawerToggle}
                        PaperProps={{
                            className: classes.drawerPaper,
                        }}
                    >
                        <AuditTrailViewer {...props} auditTrail={auditTrail} chartUniqueId={chartUniqueId} handleAuditTrailDrawerToggle={handleAuditTrailDrawerToggle} />
                    </Drawer>
                )
            }

        </div>
    )
}

export default ActionBarViewer